export default {
  label: {
    sentimentText: 'Sentimiento',
  },
};
